import { render, staticRenderFns } from "./ObjectivesProfile.vue?vue&type=template&id=6ab4ead9&scoped=true"
import script from "./ObjectivesProfile.vue?vue&type=script&lang=js"
export * from "./ObjectivesProfile.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesProfile.vue?vue&type=style&index=0&id=6ab4ead9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4ead9",
  null
  
)

export default component.exports